// export const IMG_URL = "http://192.168.16.56:4328";
// export const IMG_URL = "https://gravitydrive.newnode.profcyma.org:4328";
export const IMG_URL = "https://node.gravitydrive.in:4328";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const SelectTimeSlotData = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.TimeSlot?.id,
    label: data?.TimeSlot?.start_time + "-" + data?.TimeSlot?.end_time,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const SelectServiceCenterVehicleData = async (
  data,
  name,
  other = false,
) => {
  const result = data.map((data) => ({
    value: data?.Vehicle_Type?.id,
    label: data?.Vehicle_Type?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export const FixIDS = {
  Roles: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  Users: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  Gender: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  Category: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  TimeSlots: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  AboutUs: { List: 37, Edit: 38 },
  TermsAndConditions: { List: 39, Edit: 40 },
  PrivacyPolicy: { List: 41, Edit: 42 },
  Faqs: { List: 43, Edit: 44 },
  AppSetup: { List: 45, Edit: 46 },
};
